<template>
    <div class="fund-list">
        <el-row v-if="fundInfo.length <= 0 && hasLoad" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>{{ noFundMsg }}</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-else-if="hasLoad && pageHasLoad"
            :data="fundAll"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
        >
            <el-table-column
                label="产品名称"
                width="270"
                class-name="fund-offset"
                style="white-space: wrap"
            >
                <template slot-scope="scope">
                    <div class="fund-name" v-on:click.stop="gotoDetail(scope.row)">
                        {{ scope.row.fundname }}
                    </div>
                    <div>
                        {{ scope.row.fundcode }}
                        <!-- FOF-7 -->
                        <span
                            v-if="
                                scope.row.fundshowtype === '7' &&
                                scope.row.cycleratevalue &&
                                scope.row.cycleratetype
                            "
                        >
                            | 封闭期{{
                                scope.row.cycleratevalue +
                                $cache.getDict("220027", scope.row.cycleratetype)
                            }}
                        </span>
                        <div v-if="$util.hasFM(scope.row)" class="fm1">浮动管理费基金</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :label="
                    tabIndex == '' || tabIndex == '0'
                        ? '单位净值/万份收益'
                        : tabIndex != '5'
                        ? '单位净值'
                        : '每万份收益'
                "
                align="center"
                width="160"
            >
                <template slot-scope="scope">
                    <div v-if="scope.row.fundshowtype != '5'">
                        <div>
                            {{ $util.fmtNum(scope.row.nav, 4) }}
                        </div>
                        <div v-if="scope.row.nav" style="color: var(--color-text-accent)">
                            {{ $util.fmtDate(scope.row.navdate) }}
                        </div>
                    </div>
                    <div v-else>
                        <div>
                            {{ $util.fmtNum(scope.row.fundincomeunit, 4) }}
                        </div>
                        <div
                            v-if="scope.row.fundincomeunit"
                            style="color: var(--color-text-accent)"
                        >
                            {{ $util.fmtDate(scope.row.navdate) }}
                        </div>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column label="累计净值" align="center">
                <template slot-scope="scope">
                    <div>{{ $util.fmtNum(scope.row.totalnav, 4) }}</div>
                </template>
            </el-table-column> -->
            <el-table-column
                :label="
                    tabIndex == '' || tabIndex == '0'
                        ? '日涨跌幅/7日年化'
                        : tabIndex != '5'
                        ? '日涨跌幅'
                        : '7日年化收益'
                "
                align="center"
                width="140"
            >
                <template slot-scope="scope">
                    <span
                        v-if="scope.row.fundshowtype != '5'"
                        :class="
                            scope.row.dayfloatprofit > 0
                                ? 'add'
                                : scope.row.dayfloatprofit < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ formatterRate(scope.row.dayfloatprofit) }}
                    </span>
                    <span
                        v-else
                        :class="
                            scope.row.growthrate > 0
                                ? 'add'
                                : scope.row.growthrate < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ formatterRate(scope.row.growthrate) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="近六月" align="center">
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.month6ud > 0 ? 'add' : scope.row.month6ud < 0 ? 'reduce' : ''
                        "
                    >
                        {{ formatterRate(scope.row.month6ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="近一年" align="center">
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.year1ud > 0 ? 'add' : scope.row.year1ud < 0 ? 'reduce' : ''
                        "
                    >
                        {{ formatterRate(scope.row.year1ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="今年以来" align="center">
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.thisyear1ud > 0
                                ? 'add'
                                : scope.row.thisyear1ud < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ formatterRate(scope.row.thisyear1ud) }}
                    </span>
                </template>
            </el-table-column>
            <!-- <el-table-column label="成立以来" align="center" width="100">
                <template slot-scope="scope">
                    <span
                        :class="scope.row.allud > 0 ? 'add' : scope.row.allud < 0 ? 'reduce' : ''"
                    >
                        {{ formatterRate(scope.row.allud) }}
                    </span>
                </template>
            </el-table-column> -->
            <el-table-column label="近三年" align="center">
                <template slot-scope="scope">
                    <span
                        :class="
                            scope.row.year3ud > 0 ? 'add' : scope.row.year3ud < 0 ? 'reduce' : ''
                        "
                    >
                        {{ formatterRate(scope.row.year3ud) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="风险等级" align="center" min-width="120">
                <template slot-scope="scope">
                    <div style="white-space: nowrap">
                        {{ $cache.getDict("110143", scope.row.risklevel) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="110">
                <template slot-scope="scope">
                    <div class="btns">
                        <el-tooltip
                            v-if="scope.row.isBuy"
                            class="item"
                            effect="info"
                            :content="
                                scope.row.isBuy +
                                '，不能' +
                                (scope.row.status == '1' ? '认购' : '申购')
                            "
                            placement="top"
                        >
                            <el-button disabled type="text" size="small">
                                {{ scope.row.status == "1" ? "认购" : "申购" }}
                            </el-button>
                        </el-tooltip>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('20,22', scope.row)"
                        >
                            {{ scope.row.status == "1" ? "认购" : "申购" }}
                        </el-button>
                        <div v-if="$util.getFundClass() != '1'" class="line"></div>
                        <el-tooltip
                            v-if="scope.row.isCurrency && scope.row.fundclass != '1'"
                            class="item"
                            effect="info"
                            :content="scope.row.isCurrency + '，不能定投'"
                            placement="top"
                        >
                            <el-button disabled type="text" size="small">定投</el-button>
                        </el-tooltip>
                        <el-button
                            v-if="!scope.row.isCurrency && scope.row.fundclass != '1'"
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="callbackFn('59', scope.row)"
                        >
                            定投
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="dataReset"
            />
        </el-row>
    </div>
</template>

<script>
import fundApi from "@/api/fund";

export default {
    name: "FundList",
    props: {
        fundInfo: {
            type: Array,
            default: () => {
                return [];
            },
            required: true
        },
        allPage: {
            type: String,
            default: ""
        },
        noFundMsg: {
            type: String,
            default: "基金公司没有添加基金产品，请联系基金公司添加！ "
        },
        isCollection: {
            type: Boolean,
            default: false
        },
        hasLoad: {
            type: Boolean,
            default: false
        },
        tabIndex: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            url: "", // 当前页面路由命名
            fundAll: [],
            curPage: 1,
            pageHasLoad: true
        };
    },
    watch: {
        fundInfo() {
            this.getNewFund("fundInfo");
        },
        tabIndex() {
            this.getNewFund("tabIndex");
        },
        allPage() {
            this.curPage = 1;
        }
    },
    mounted() {
        this.conf = this.$util.getConfig().const;
        this.url = this.$route.name;
    },
    methods: {
        gotoDetail(val) {
            this.$util.toFundDetailPage(val.fundcode);
        },
        // 关注基金
        async collectFund(item) {
            const res = await fundApi.collectFund({
                fundcode: item.fundcode
            });
            if (!res.error) {
                this.$set(this.fundAll[item.index], "collection", "1");
            }
        },
        // 取消关注基金
        async unCollectFund(item) {
            const res = await fundApi.unCollectFund({
                fundcode: item.fundcode
            });
            if (!res.error) {
                this.$set(this.fundAll[item.index], "collection", "0");
            }
        },
        callbackFn(way, fund) {
            let moduleId = "";
            if (way == "59") {
                moduleId = way;
            } else {
                if (fund.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            }
            // 申购 22 认购 20
            this.$util.checkGtOcrModule(moduleId, "0", (res) => {
                this.$emit("fund-continue", way, fund);
            });
        },
        getNewFund(val) {
            this.pageHasLoad = false;
            let _arr = [];
            this.fundInfo.forEach((fund, index) => {
                const _x = Object.assign({}, fund);
                _x.index = index;
                _x.isBuy = this.$util.checkBuy(_x);
                _x.isCurrency = this.$util.checkGeneral(_x);
                _arr.push(_x);
            });
            this.fundAll = _arr;
            if (val == "fundInfo") {
                this.pageHasLoad = true;
            }
        },
        dataReset(val) {
            this.$emit("new-fund", val);
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (rate === "" || rate === null) {
                return "--";
            }
            const prefix = Number(rate) > 0 ? "+" : "";
            return prefix + this.$util.fmtNum(rate) + "%";
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";

.el-table td.el-table__cell div {
    color: var(--color-text-primary);
    font-weight: 400;
}

.el-table td.el-table__cell span {
    color: var(--color-text-primary);
    font-weight: 400;

    &.add {
        color: var(--color-up);
    }

    &.reduce {
        color: var(--color-down);
    }
}

.fund-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}

.btns {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
}

.line {
    background: var(--color-divided);
    width: 1px;
    height: 12px;
}

// .el-pager li {
//     background: transparent;
// }
// .el-pagination .btn-prev, .el-pagination .btn-next {
//     background-color: transparent;
// }
// .el-pagination button:disabled {
//     background-color: transparent;
// }
.el-pagination {
    margin-bottom: 0;
}

.el-button.is-plain:hover,
.el-button.is-plain:focus,
.el-button.is-disabled.is-plain {
    background-color: transparent;
    border-color: transparent;
}

.el-button--text {
    font-size: 14px;
    font-weight: 400;
    color: var(--color-primary);
}

.el-button--text.is-disabled {
    color: var(--color-text-weak);
}

.el-table {
    border: 1px solid var(--color-divided);
}
.el-table--fit {
    margin-bottom: 15px;
}
</style>
